import { useState } from 'react';
import {
  Flex,
  Text,
  Select,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  useDisclosure,
} from '@chakra-ui/react';
import { Button, SubmissionPrompt, TitleText } from 'components';

type AssignAgencyProps = {
  user: UserData;
  agencies: Agency[];
  close: () => void;
  assignAction: (agencyId: string) => void;
};

const AssignAgency = ({
  user,
  agencies,
  close,
  assignAction,
}: AssignAgencyProps): JSX.Element => {
  const [agency, setAgency] = useState('');
  const { isOpen, onOpen, onClose } = useDisclosure();

  const assignedAgenciesMap =
    user?.agencies?.reduce((acc, val) => {
      acc = { ...acc, [val]: true };
      return acc;
    }, {} as IIndexable) || ({} as IIndexable);

  const handleAssign = () => {
    if (user?.agencies?.length) {
      onOpen();
    } else {
      assignAction(agency);
    }
  };

  return (
    <>
      {isOpen ? (
        <SubmissionPrompt
          title={`Reassign ${user?.firstname || ''} ${user?.lastname || ''}?`}
          description="Are you sure you want to reassign the caregiver to a new agency? Their current assignment will be deacitvated"
          positiveTitle="Assign"
          open={isOpen}
          onClose={onClose}
          processRequest={() => {
            onClose();
            assignAction(agency);
          }}
        />
      ) : (
        <Modal isOpen={true} onClose={close}>
          <ModalOverlay />
          <ModalContent
            alignSelf="center"
            width={['100vw', '80vw', '70vw', '60vw']}
            my={0}
            borderRadius={0}
          >
            <ModalHeader>
              <TitleText
                color="custom.levoBlack"
                text={`Assign ${user?.firstname || ''} ${
                  user?.lastname || ''
                } an Agency`.replace(/\s{2}/g, ' ')}
              />
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody flexGrow={1}>
              <Flex direction="column" height="100%">
                <Flex
                  direction="row"
                  alignItems="center"
                  mr={[0, 0, 0, 4]}
                  mb={[4, 4, 4, 0]}
                >
                  <Text
                    fontFamily="Lato"
                    fontWeight={700}
                    fontSize="16px"
                    lineHeight="19.2px"
                    mr={2}
                  >
                    Category:
                  </Text>
                  <Select
                    placeholder="Select agency"
                    value={agency}
                    onChange={(e) => {
                      setAgency(e.target.value);
                    }}
                  >
                    {agencies
                      .filter(({ id }) => !assignedAgenciesMap[id])
                      .map((agency) => (
                        <option key={agency.id} value={agency.id}>
                          {agency.name}
                        </option>
                      ))}
                  </Select>
                </Flex>
                <Flex
                  direction="column"
                  alignItems="center"
                  justifyContent="flex-end"
                  flexGrow={1}
                >
                  <Button
                    width={['100%', '80%', '60%', '50%']}
                    mt={4}
                    mb={4}
                    onClick={handleAssign}
                    text="Assign"
                    disabled={!agency}
                  />
                </Flex>
              </Flex>
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

export default AssignAgency;
